export default __webpack_public_path__ + "static/media/redditDeskFill.ec4a2af3.svg";